<template>
  <div style="background-color:#ffffff;background-image:url('/src/assets/timecure-login.gif');">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/auth/SignUp.vue